import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as SuccessOutlinedSvg } from './assets/success-outlined.svg';

const SuccessOutlined = React.forwardRef((args, ref) => <SvgIcon component={SuccessOutlinedSvg} ref={ref} {...args} />);

export default SuccessOutlined;
